import React from 'react'

import {Typography, Accordion,AccordionSummary, ButtonGroup } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

function SampleData({onLoadSample}) {
    const sampleDrone1 = JSON.stringify(
        [
            {
                "id": "drone1",
                "path": [
                    { "lat": 18.5204, "lng": 73.8567 },
                    { "lat": 18.5630, "lng": 73.9097 },
                    { "lat": 18.5932, "lng": 73.9483 },
                    { "lat": 18.6231, "lng": 73.9770 },
                    { "lat": 18.6540, "lng": 74.0044 },
                    { "lat": 18.6844, "lng": 74.0320 },
                    { "lat": 18.7151, "lng": 74.0600 },
                    { "lat": 18.7462, "lng": 74.0893 },
                    { "lat": 18.7757, "lng": 74.1200 },
                    { "lat": 18.8054, "lng": 74.1492 },
                    { "lat": 18.8351, "lng": 74.1770 },
                    { "lat": 18.8651, "lng": 74.2054 },
                    { "lat": 18.8948, "lng": 74.2324 },
                    { "lat": 18.9244, "lng": 74.2602 },
                    { "lat": 18.9539, "lng": 74.2880 },
                    { "lat": 18.9836, "lng": 74.3156 },
                    { "lat": 19.0131, "lng": 74.3435 },
                    { "lat": 19.0432, "lng": 74.3710 },
                    { "lat": 19.0730, "lng": 74.3988 },
                    { "lat": 19.1025, "lng": 74.4265 },
                    { "lat": 19.1323, "lng": 74.4535 },
                    { "lat": 19.1621, "lng": 74.4805 },
                    { "lat": 19.1920, "lng": 74.5075 },
                    { "lat": 19.2218, "lng": 74.5345 },
                    { "lat": 19.2515, "lng": 74.5615 },
                    { "lat": 19.2811, "lng": 74.5886 },
                    { "lat": 19.3112, "lng": 74.6162 },
                    { "lat": 19.3410, "lng": 74.6442 },
                    { "lat": 19.3711, "lng": 74.6715 },
                    { "lat": 19.4012, "lng": 74.6985 },
                    { "lat": 19.4311, "lng": 74.7256 },
                    { "lat": 19.4611, "lng": 74.7527 },
                    { "lat": 19.4910, "lng": 74.7796 },
                    { "lat": 19.5209, "lng": 74.8067 },
                    { "lat": 19.5509, "lng": 74.8338 },
                    { "lat": 19.5808, "lng": 74.8609 },
                    { "lat": 19.6108, "lng": 74.8880 },
                    { "lat": 19.6407, "lng": 74.9151 },
                    { "lat": 19.6707, "lng": 74.9421 },
                    { "lat": 19.7006, "lng": 74.9692 },
                    { "lat": 19.7306, "lng": 74.9963 },
                    { "lat": 19.7605, "lng": 75.0233 },
                    { "lat": 19.7905, "lng": 75.0504 },
                    { "lat": 19.8204, "lng": 75.0775 },
                    { "lat": 19.8504, "lng": 75.1046 },
                    { "lat": 19.8803, "lng": 75.1317 },
                    { "lat": 19.9103, "lng": 75.1587 },
                    { "lat": 19.9402, "lng": 75.1858 },
                    { "lat": 19.9702, "lng": 75.2129 },
                    { "lat": 20.0001, "lng": 75.2400 },
                    { "lat": 20.0301, "lng": 75.2671 },
                    { "lat": 20.0601, "lng": 75.2942 },
                    { "lat": 20.0901, "lng": 75.3212 },
                    { "lat": 20.1200, "lng": 75.3483 },
                    { "lat": 20.1500, "lng": 75.3754 },
                    { "lat": 20.1800, "lng": 75.4025 },
                    { "lat": 20.2100, "lng": 75.4295 },
                    { "lat": 20.2400, "lng": 75.4566 },
                    { "lat": 20.2700, "lng": 75.4837 },
                  ]                              
              },
        ],null,2
    );
  const sampleDrone2 = JSON.stringify([
    {
        "id": "drone2",
        "path": [
            { "lat": 28.6139, "lng": 77.2090 },
            { "lat": 28.6250, "lng": 77.2110 },
            { "lat": 28.6200, "lng": 77.2125 },
            { "lat": 28.6180, "lng": 77.2140 },
            { "lat": 28.6205, "lng": 77.2180 },
            { "lat": 28.6255, "lng": 77.2205 },
            { "lat": 28.6300, "lng": 77.2250 },
            { "lat": 28.6330, "lng": 77.2305 },
            { "lat": 28.6355, "lng": 77.2355 },
            { "lat": 28.6400, "lng": 77.2390 },
            { "lat": 28.6450, "lng": 77.2405 },
            { "lat": 28.6485, "lng": 77.2435 },
            { "lat": 28.6505, "lng": 77.2470 },
            { "lat": 28.6550, "lng": 77.2515 },
            { "lat": 28.6605, "lng": 77.2555 },
            { "lat": 28.6635, "lng": 77.2585 },
            { "lat": 28.6665, "lng": 77.2610 },
            { "lat": 28.6700, "lng": 77.2645 },
            { "lat": 28.6730, "lng": 77.2680 },
            { "lat": 28.6760, "lng": 77.2720 },
            { "lat": 28.6795, "lng": 77.2755 },
            { "lat": 28.6825, "lng": 77.2790 },
            { "lat": 28.6855, "lng": 77.2825 },
            { "lat": 28.6880, "lng": 77.2855 },
            { "lat": 28.6905, "lng": 77.2885 },
            { "lat": 28.6935, "lng": 77.2925 },
            { "lat": 28.6965, "lng": 77.2965 },
            { "lat": 28.6990, "lng": 77.2995 },
            { "lat": 28.7025, "lng": 77.3035 },
            { "lat": 28.7055, "lng": 77.3070 },
            { "lat": 28.7090, "lng": 77.3110 },
            { "lat": 28.7115, "lng": 77.3145 },
            { "lat": 28.7145, "lng": 77.3185 },
            { "lat": 28.7175, "lng": 77.3215 },
            { "lat": 28.7200, "lng": 77.3250 },
            { "lat": 28.7235, "lng": 77.3285 },
            { "lat": 28.7260, "lng": 77.3325 },
            { "lat": 28.7290, "lng": 77.3360 },
            { "lat": 28.7320, "lng": 77.3395 },
            { "lat": 28.7345, "lng": 77.3435 },
            { "lat": 28.7375, "lng": 77.3465 },
            { "lat": 28.7405, "lng": 77.3500 },
            { "lat": 28.7435, "lng": 77.3530 },
            { "lat": 28.7465, "lng": 77.3560 },
            { "lat": 28.7495, "lng": 77.3590 },
            { "lat": 28.7525, "lng": 77.3625 },
            { "lat": 28.7555, "lng": 77.3660 },
            { "lat": 28.7585, "lng": 77.3695 },
            { "lat": 28.7615, "lng": 77.3730 },
            { "lat": 28.7645, "lng": 77.3765 },
            { "lat": 28.7675, "lng": 77.3795 },
            { "lat": 28.7705, "lng": 77.3825 }, 
            { "lat": 28.7735, "lng": 77.3860 },
            { "lat": 28.7765, "lng": 77.3895 },
            { "lat": 28.7795, "lng": 77.3925 },
            { "lat": 28.7825, "lng": 77.3960 },
            { "lat": 28.7855, "lng": 77.3990 },
          ]
          
      },
  ], null, 2);

  const sampleDrone3 = JSON.stringify([
    {
        "id": "drone3",
        "path": [
          { "lat": 8.524139, "lng": 76.936638 },   // Kochi
          { "lat": 19.218330, "lng": 72.978088 },  // Mumbai Suburb
          { "lat": 28.535517, "lng": 77.391029 },  // Noida
          { "lat": 26.912433, "lng": 75.787270 },  // Jaipur
          { "lat": 10.792600, "lng": 78.704140 }   // Madurai
        ]
      },
  ], null, 2);


  return (
    <div>
        <Accordion sx={{m:0.5,mt:1, backgroundColor:"#18181b"}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{color:"#fff"}}/>}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" color="#fff">Sample Data</Typography>
        </AccordionSummary>
        <ButtonGroup variant="outlined" aria-label="Basic button group" color="secondary" sx={{m:1}}>
            <Button size='small' onClick={()=> onLoadSample(sampleDrone1)} onSubmit={()=>{}} >Load Drone 1</Button>
            <Button size='small' onClick={()=> onLoadSample(sampleDrone2)} onSubmit={()=>{}} >Load Drone 2</Button>
            <Button size='small' onClick={()=>onLoadSample(sampleDrone3)} onSubmit={()=>{}} >Load Drone 3</Button>
        </ButtonGroup>
      </Accordion>
    </div>
  )
}

export default SampleData